var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target, mod));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var globals_exports = {};
__export(globals_exports, {
  AuState: () => AuState,
  Brand: () => Brand,
  DayOfWeek: () => DayOfWeek,
  DevicePlatform: () => DevicePlatform,
  Interval: () => Interval,
  Interval_Type: () => Interval_Type,
  LanguageCode: () => LanguageCode,
  PageRequest: () => PageRequest,
  Pharmacy: () => Pharmacy,
  ProblemType: () => ProblemType,
  QuizCode: () => QuizCode,
  auStateFromJSON: () => auStateFromJSON,
  auStateToJSON: () => auStateToJSON,
  brandFromJSON: () => brandFromJSON,
  brandToJSON: () => brandToJSON,
  dayOfWeekFromJSON: () => dayOfWeekFromJSON,
  dayOfWeekToJSON: () => dayOfWeekToJSON,
  devicePlatformFromJSON: () => devicePlatformFromJSON,
  devicePlatformToJSON: () => devicePlatformToJSON,
  interval_TypeFromJSON: () => interval_TypeFromJSON,
  interval_TypeToJSON: () => interval_TypeToJSON,
  languageCodeFromJSON: () => languageCodeFromJSON,
  languageCodeToJSON: () => languageCodeToJSON,
  pharmacyFromJSON: () => pharmacyFromJSON,
  pharmacyToJSON: () => pharmacyToJSON,
  problemTypeFromJSON: () => problemTypeFromJSON,
  problemTypeToJSON: () => problemTypeToJSON,
  protobufPackage: () => protobufPackage,
  quizCodeFromJSON: () => quizCodeFromJSON,
  quizCodeToJSON: () => quizCodeToJSON
});
module.exports = __toCommonJS(globals_exports);
var import_minimal = __toESM(require("protobufjs/minimal"));
var import_wrappers = require("./google/protobuf/wrappers");
const protobufPackage = "globals";
var Brand = /* @__PURE__ */ ((Brand2) => {
  Brand2[Brand2["BRAND_UNSPECIFIED"] = 0] = "BRAND_UNSPECIFIED";
  Brand2[Brand2["BRAND_PILOT"] = 1] = "BRAND_PILOT";
  Brand2[Brand2["BRAND_KIN"] = 2] = "BRAND_KIN";
  Brand2[Brand2["BRAND_SOFTWARE"] = 3] = "BRAND_SOFTWARE";
  Brand2[Brand2["BRAND_JUNIPER"] = 4] = "BRAND_JUNIPER";
  Brand2[Brand2["BRAND_JUNIPER_UK"] = 5] = "BRAND_JUNIPER_UK";
  Brand2[Brand2["BRAND_JUNIPER_DE"] = 6] = "BRAND_JUNIPER_DE";
  Brand2[Brand2["BRAND_JUNIPER_JP"] = 7] = "BRAND_JUNIPER_JP";
  Brand2[Brand2["BRAND_COMPOUND_UK"] = 8] = "BRAND_COMPOUND_UK";
  Brand2[Brand2["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
  return Brand2;
})(Brand || {});
function brandFromJSON(object) {
  switch (object) {
    case 0:
    case "BRAND_UNSPECIFIED":
      return 0 /* BRAND_UNSPECIFIED */;
    case 1:
    case "BRAND_PILOT":
      return 1 /* BRAND_PILOT */;
    case 2:
    case "BRAND_KIN":
      return 2 /* BRAND_KIN */;
    case 3:
    case "BRAND_SOFTWARE":
      return 3 /* BRAND_SOFTWARE */;
    case 4:
    case "BRAND_JUNIPER":
      return 4 /* BRAND_JUNIPER */;
    case 5:
    case "BRAND_JUNIPER_UK":
      return 5 /* BRAND_JUNIPER_UK */;
    case 6:
    case "BRAND_JUNIPER_DE":
      return 6 /* BRAND_JUNIPER_DE */;
    case 7:
    case "BRAND_JUNIPER_JP":
      return 7 /* BRAND_JUNIPER_JP */;
    case 8:
    case "BRAND_COMPOUND_UK":
      return 8 /* BRAND_COMPOUND_UK */;
    case -1:
    case "UNRECOGNIZED":
    default:
      return -1 /* UNRECOGNIZED */;
  }
}
function brandToJSON(object) {
  switch (object) {
    case 0 /* BRAND_UNSPECIFIED */:
      return "BRAND_UNSPECIFIED";
    case 1 /* BRAND_PILOT */:
      return "BRAND_PILOT";
    case 2 /* BRAND_KIN */:
      return "BRAND_KIN";
    case 3 /* BRAND_SOFTWARE */:
      return "BRAND_SOFTWARE";
    case 4 /* BRAND_JUNIPER */:
      return "BRAND_JUNIPER";
    case 5 /* BRAND_JUNIPER_UK */:
      return "BRAND_JUNIPER_UK";
    case 6 /* BRAND_JUNIPER_DE */:
      return "BRAND_JUNIPER_DE";
    case 7 /* BRAND_JUNIPER_JP */:
      return "BRAND_JUNIPER_JP";
    case 8 /* BRAND_COMPOUND_UK */:
      return "BRAND_COMPOUND_UK";
    case -1 /* UNRECOGNIZED */:
    default:
      return "UNRECOGNIZED";
  }
}
var ProblemType = /* @__PURE__ */ ((ProblemType2) => {
  ProblemType2[ProblemType2["PROBLEM_TYPE_UNSPECIFIED"] = 0] = "PROBLEM_TYPE_UNSPECIFIED";
  ProblemType2[ProblemType2["PROBLEM_TYPE_ACNE"] = 1] = "PROBLEM_TYPE_ACNE";
  ProblemType2[ProblemType2["PROBLEM_TYPE_ANTI_AGEING"] = 2] = "PROBLEM_TYPE_ANTI_AGEING";
  ProblemType2[ProblemType2["PROBLEM_TYPE_BREASTFEEDING"] = 3] = "PROBLEM_TYPE_BREASTFEEDING";
  ProblemType2[ProblemType2["PROBLEM_TYPE_COLD_SORES"] = 4] = "PROBLEM_TYPE_COLD_SORES";
  ProblemType2[ProblemType2["PROBLEM_TYPE_CONTRACEPTION"] = 5] = "PROBLEM_TYPE_CONTRACEPTION";
  ProblemType2[ProblemType2["PROBLEM_TYPE_DEPRECATED_OTC"] = 6] = "PROBLEM_TYPE_DEPRECATED_OTC";
  ProblemType2[ProblemType2["PROBLEM_TYPE_ERECTILE"] = 7] = "PROBLEM_TYPE_ERECTILE";
  ProblemType2[ProblemType2["PROBLEM_TYPE_FERTILITY"] = 8] = "PROBLEM_TYPE_FERTILITY";
  ProblemType2[ProblemType2["PROBLEM_TYPE_FERTILITY_HORMONE"] = 9] = "PROBLEM_TYPE_FERTILITY_HORMONE";
  ProblemType2[ProblemType2["PROBLEM_TYPE_FERTILITY_NAVIGATOR"] = 10] = "PROBLEM_TYPE_FERTILITY_NAVIGATOR";
  ProblemType2[ProblemType2["PROBLEM_TYPE_FERTILITY_NAVIGATOR_PREGNANCY"] = 11] = "PROBLEM_TYPE_FERTILITY_NAVIGATOR_PREGNANCY";
  ProblemType2[ProblemType2["PROBLEM_TYPE_GENETIC_TEST"] = 12] = "PROBLEM_TYPE_GENETIC_TEST";
  ProblemType2[ProblemType2["PROBLEM_TYPE_HAIR"] = 13] = "PROBLEM_TYPE_HAIR";
  ProblemType2[ProblemType2["PROBLEM_TYPE_HERPES"] = 14] = "PROBLEM_TYPE_HERPES";
  ProblemType2[ProblemType2["PROBLEM_TYPE_INFANT_SLEEP"] = 15] = "PROBLEM_TYPE_INFANT_SLEEP";
  ProblemType2[ProblemType2["PROBLEM_TYPE_MENOPAUSE"] = 16] = "PROBLEM_TYPE_MENOPAUSE";
  ProblemType2[ProblemType2["PROBLEM_TYPE_MENTAL_HEALTH_GOOD"] = 17] = "PROBLEM_TYPE_MENTAL_HEALTH_GOOD";
  ProblemType2[ProblemType2["PROBLEM_TYPE_MENTAL_HEALTH_MEH"] = 18] = "PROBLEM_TYPE_MENTAL_HEALTH_MEH";
  ProblemType2[ProblemType2["PROBLEM_TYPE_MENTAL_HEALTH_SAD"] = 19] = "PROBLEM_TYPE_MENTAL_HEALTH_SAD";
  ProblemType2[ProblemType2["PROBLEM_TYPE_POSTPARTUM"] = 20] = "PROBLEM_TYPE_POSTPARTUM";
  ProblemType2[ProblemType2["PROBLEM_TYPE_POSTPARTUM_MENTAL_HEALTH"] = 21] = "PROBLEM_TYPE_POSTPARTUM_MENTAL_HEALTH";
  ProblemType2[ProblemType2["PROBLEM_TYPE_POSTPARTUM_NUTRITION"] = 22] = "PROBLEM_TYPE_POSTPARTUM_NUTRITION";
  ProblemType2[ProblemType2["PROBLEM_TYPE_POSTPARTUM_PHYSIO"] = 23] = "PROBLEM_TYPE_POSTPARTUM_PHYSIO";
  ProblemType2[ProblemType2["PROBLEM_TYPE_PRECONCEPTION_FERTILITY"] = 24] = "PROBLEM_TYPE_PRECONCEPTION_FERTILITY";
  ProblemType2[ProblemType2["PROBLEM_TYPE_PRECONCEPTION_MENTAL_HEALTH"] = 25] = "PROBLEM_TYPE_PRECONCEPTION_MENTAL_HEALTH";
  ProblemType2[ProblemType2["PROBLEM_TYPE_PRECONCEPTION_NUTRITION"] = 26] = "PROBLEM_TYPE_PRECONCEPTION_NUTRITION";
  ProblemType2[ProblemType2["PROBLEM_TYPE_PRECONCEPTION_PHYSIO"] = 27] = "PROBLEM_TYPE_PRECONCEPTION_PHYSIO";
  ProblemType2[ProblemType2["PROBLEM_TYPE_PREGNANCY"] = 28] = "PROBLEM_TYPE_PREGNANCY";
  ProblemType2[ProblemType2["PROBLEM_TYPE_PREGNANCY_MENTAL_HEALTH"] = 29] = "PROBLEM_TYPE_PREGNANCY_MENTAL_HEALTH";
  ProblemType2[ProblemType2["PROBLEM_TYPE_PREGNANCY_NUTRITION"] = 30] = "PROBLEM_TYPE_PREGNANCY_NUTRITION";
  ProblemType2[ProblemType2["PROBLEM_TYPE_PREGNANCY_PHYSIO"] = 31] = "PROBLEM_TYPE_PREGNANCY_PHYSIO";
  ProblemType2[ProblemType2["PROBLEM_TYPE_PREMATURE"] = 32] = "PROBLEM_TYPE_PREMATURE";
  ProblemType2[ProblemType2["PROBLEM_TYPE_SKIN_GENERAL"] = 33] = "PROBLEM_TYPE_SKIN_GENERAL";
  ProblemType2[ProblemType2["PROBLEM_TYPE_SLEEP"] = 34] = "PROBLEM_TYPE_SLEEP";
  ProblemType2[ProblemType2["PROBLEM_TYPE_STI"] = 35] = "PROBLEM_TYPE_STI";
  ProblemType2[ProblemType2["PROBLEM_TYPE_UTI"] = 36] = "PROBLEM_TYPE_UTI";
  ProblemType2[ProblemType2["PROBLEM_TYPE_WEIGHT_LOSS"] = 37] = "PROBLEM_TYPE_WEIGHT_LOSS";
  ProblemType2[ProblemType2["PROBLEM_TYPE_WOMENS_HEALTH"] = 38] = "PROBLEM_TYPE_WOMENS_HEALTH";
  ProblemType2[ProblemType2["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
  return ProblemType2;
})(ProblemType || {});
function problemTypeFromJSON(object) {
  switch (object) {
    case 0:
    case "PROBLEM_TYPE_UNSPECIFIED":
      return 0 /* PROBLEM_TYPE_UNSPECIFIED */;
    case 1:
    case "PROBLEM_TYPE_ACNE":
      return 1 /* PROBLEM_TYPE_ACNE */;
    case 2:
    case "PROBLEM_TYPE_ANTI_AGEING":
      return 2 /* PROBLEM_TYPE_ANTI_AGEING */;
    case 3:
    case "PROBLEM_TYPE_BREASTFEEDING":
      return 3 /* PROBLEM_TYPE_BREASTFEEDING */;
    case 4:
    case "PROBLEM_TYPE_COLD_SORES":
      return 4 /* PROBLEM_TYPE_COLD_SORES */;
    case 5:
    case "PROBLEM_TYPE_CONTRACEPTION":
      return 5 /* PROBLEM_TYPE_CONTRACEPTION */;
    case 6:
    case "PROBLEM_TYPE_DEPRECATED_OTC":
      return 6 /* PROBLEM_TYPE_DEPRECATED_OTC */;
    case 7:
    case "PROBLEM_TYPE_ERECTILE":
      return 7 /* PROBLEM_TYPE_ERECTILE */;
    case 8:
    case "PROBLEM_TYPE_FERTILITY":
      return 8 /* PROBLEM_TYPE_FERTILITY */;
    case 9:
    case "PROBLEM_TYPE_FERTILITY_HORMONE":
      return 9 /* PROBLEM_TYPE_FERTILITY_HORMONE */;
    case 10:
    case "PROBLEM_TYPE_FERTILITY_NAVIGATOR":
      return 10 /* PROBLEM_TYPE_FERTILITY_NAVIGATOR */;
    case 11:
    case "PROBLEM_TYPE_FERTILITY_NAVIGATOR_PREGNANCY":
      return 11 /* PROBLEM_TYPE_FERTILITY_NAVIGATOR_PREGNANCY */;
    case 12:
    case "PROBLEM_TYPE_GENETIC_TEST":
      return 12 /* PROBLEM_TYPE_GENETIC_TEST */;
    case 13:
    case "PROBLEM_TYPE_HAIR":
      return 13 /* PROBLEM_TYPE_HAIR */;
    case 14:
    case "PROBLEM_TYPE_HERPES":
      return 14 /* PROBLEM_TYPE_HERPES */;
    case 15:
    case "PROBLEM_TYPE_INFANT_SLEEP":
      return 15 /* PROBLEM_TYPE_INFANT_SLEEP */;
    case 16:
    case "PROBLEM_TYPE_MENOPAUSE":
      return 16 /* PROBLEM_TYPE_MENOPAUSE */;
    case 17:
    case "PROBLEM_TYPE_MENTAL_HEALTH_GOOD":
      return 17 /* PROBLEM_TYPE_MENTAL_HEALTH_GOOD */;
    case 18:
    case "PROBLEM_TYPE_MENTAL_HEALTH_MEH":
      return 18 /* PROBLEM_TYPE_MENTAL_HEALTH_MEH */;
    case 19:
    case "PROBLEM_TYPE_MENTAL_HEALTH_SAD":
      return 19 /* PROBLEM_TYPE_MENTAL_HEALTH_SAD */;
    case 20:
    case "PROBLEM_TYPE_POSTPARTUM":
      return 20 /* PROBLEM_TYPE_POSTPARTUM */;
    case 21:
    case "PROBLEM_TYPE_POSTPARTUM_MENTAL_HEALTH":
      return 21 /* PROBLEM_TYPE_POSTPARTUM_MENTAL_HEALTH */;
    case 22:
    case "PROBLEM_TYPE_POSTPARTUM_NUTRITION":
      return 22 /* PROBLEM_TYPE_POSTPARTUM_NUTRITION */;
    case 23:
    case "PROBLEM_TYPE_POSTPARTUM_PHYSIO":
      return 23 /* PROBLEM_TYPE_POSTPARTUM_PHYSIO */;
    case 24:
    case "PROBLEM_TYPE_PRECONCEPTION_FERTILITY":
      return 24 /* PROBLEM_TYPE_PRECONCEPTION_FERTILITY */;
    case 25:
    case "PROBLEM_TYPE_PRECONCEPTION_MENTAL_HEALTH":
      return 25 /* PROBLEM_TYPE_PRECONCEPTION_MENTAL_HEALTH */;
    case 26:
    case "PROBLEM_TYPE_PRECONCEPTION_NUTRITION":
      return 26 /* PROBLEM_TYPE_PRECONCEPTION_NUTRITION */;
    case 27:
    case "PROBLEM_TYPE_PRECONCEPTION_PHYSIO":
      return 27 /* PROBLEM_TYPE_PRECONCEPTION_PHYSIO */;
    case 28:
    case "PROBLEM_TYPE_PREGNANCY":
      return 28 /* PROBLEM_TYPE_PREGNANCY */;
    case 29:
    case "PROBLEM_TYPE_PREGNANCY_MENTAL_HEALTH":
      return 29 /* PROBLEM_TYPE_PREGNANCY_MENTAL_HEALTH */;
    case 30:
    case "PROBLEM_TYPE_PREGNANCY_NUTRITION":
      return 30 /* PROBLEM_TYPE_PREGNANCY_NUTRITION */;
    case 31:
    case "PROBLEM_TYPE_PREGNANCY_PHYSIO":
      return 31 /* PROBLEM_TYPE_PREGNANCY_PHYSIO */;
    case 32:
    case "PROBLEM_TYPE_PREMATURE":
      return 32 /* PROBLEM_TYPE_PREMATURE */;
    case 33:
    case "PROBLEM_TYPE_SKIN_GENERAL":
      return 33 /* PROBLEM_TYPE_SKIN_GENERAL */;
    case 34:
    case "PROBLEM_TYPE_SLEEP":
      return 34 /* PROBLEM_TYPE_SLEEP */;
    case 35:
    case "PROBLEM_TYPE_STI":
      return 35 /* PROBLEM_TYPE_STI */;
    case 36:
    case "PROBLEM_TYPE_UTI":
      return 36 /* PROBLEM_TYPE_UTI */;
    case 37:
    case "PROBLEM_TYPE_WEIGHT_LOSS":
      return 37 /* PROBLEM_TYPE_WEIGHT_LOSS */;
    case 38:
    case "PROBLEM_TYPE_WOMENS_HEALTH":
      return 38 /* PROBLEM_TYPE_WOMENS_HEALTH */;
    case -1:
    case "UNRECOGNIZED":
    default:
      return -1 /* UNRECOGNIZED */;
  }
}
function problemTypeToJSON(object) {
  switch (object) {
    case 0 /* PROBLEM_TYPE_UNSPECIFIED */:
      return "PROBLEM_TYPE_UNSPECIFIED";
    case 1 /* PROBLEM_TYPE_ACNE */:
      return "PROBLEM_TYPE_ACNE";
    case 2 /* PROBLEM_TYPE_ANTI_AGEING */:
      return "PROBLEM_TYPE_ANTI_AGEING";
    case 3 /* PROBLEM_TYPE_BREASTFEEDING */:
      return "PROBLEM_TYPE_BREASTFEEDING";
    case 4 /* PROBLEM_TYPE_COLD_SORES */:
      return "PROBLEM_TYPE_COLD_SORES";
    case 5 /* PROBLEM_TYPE_CONTRACEPTION */:
      return "PROBLEM_TYPE_CONTRACEPTION";
    case 6 /* PROBLEM_TYPE_DEPRECATED_OTC */:
      return "PROBLEM_TYPE_DEPRECATED_OTC";
    case 7 /* PROBLEM_TYPE_ERECTILE */:
      return "PROBLEM_TYPE_ERECTILE";
    case 8 /* PROBLEM_TYPE_FERTILITY */:
      return "PROBLEM_TYPE_FERTILITY";
    case 9 /* PROBLEM_TYPE_FERTILITY_HORMONE */:
      return "PROBLEM_TYPE_FERTILITY_HORMONE";
    case 10 /* PROBLEM_TYPE_FERTILITY_NAVIGATOR */:
      return "PROBLEM_TYPE_FERTILITY_NAVIGATOR";
    case 11 /* PROBLEM_TYPE_FERTILITY_NAVIGATOR_PREGNANCY */:
      return "PROBLEM_TYPE_FERTILITY_NAVIGATOR_PREGNANCY";
    case 12 /* PROBLEM_TYPE_GENETIC_TEST */:
      return "PROBLEM_TYPE_GENETIC_TEST";
    case 13 /* PROBLEM_TYPE_HAIR */:
      return "PROBLEM_TYPE_HAIR";
    case 14 /* PROBLEM_TYPE_HERPES */:
      return "PROBLEM_TYPE_HERPES";
    case 15 /* PROBLEM_TYPE_INFANT_SLEEP */:
      return "PROBLEM_TYPE_INFANT_SLEEP";
    case 16 /* PROBLEM_TYPE_MENOPAUSE */:
      return "PROBLEM_TYPE_MENOPAUSE";
    case 17 /* PROBLEM_TYPE_MENTAL_HEALTH_GOOD */:
      return "PROBLEM_TYPE_MENTAL_HEALTH_GOOD";
    case 18 /* PROBLEM_TYPE_MENTAL_HEALTH_MEH */:
      return "PROBLEM_TYPE_MENTAL_HEALTH_MEH";
    case 19 /* PROBLEM_TYPE_MENTAL_HEALTH_SAD */:
      return "PROBLEM_TYPE_MENTAL_HEALTH_SAD";
    case 20 /* PROBLEM_TYPE_POSTPARTUM */:
      return "PROBLEM_TYPE_POSTPARTUM";
    case 21 /* PROBLEM_TYPE_POSTPARTUM_MENTAL_HEALTH */:
      return "PROBLEM_TYPE_POSTPARTUM_MENTAL_HEALTH";
    case 22 /* PROBLEM_TYPE_POSTPARTUM_NUTRITION */:
      return "PROBLEM_TYPE_POSTPARTUM_NUTRITION";
    case 23 /* PROBLEM_TYPE_POSTPARTUM_PHYSIO */:
      return "PROBLEM_TYPE_POSTPARTUM_PHYSIO";
    case 24 /* PROBLEM_TYPE_PRECONCEPTION_FERTILITY */:
      return "PROBLEM_TYPE_PRECONCEPTION_FERTILITY";
    case 25 /* PROBLEM_TYPE_PRECONCEPTION_MENTAL_HEALTH */:
      return "PROBLEM_TYPE_PRECONCEPTION_MENTAL_HEALTH";
    case 26 /* PROBLEM_TYPE_PRECONCEPTION_NUTRITION */:
      return "PROBLEM_TYPE_PRECONCEPTION_NUTRITION";
    case 27 /* PROBLEM_TYPE_PRECONCEPTION_PHYSIO */:
      return "PROBLEM_TYPE_PRECONCEPTION_PHYSIO";
    case 28 /* PROBLEM_TYPE_PREGNANCY */:
      return "PROBLEM_TYPE_PREGNANCY";
    case 29 /* PROBLEM_TYPE_PREGNANCY_MENTAL_HEALTH */:
      return "PROBLEM_TYPE_PREGNANCY_MENTAL_HEALTH";
    case 30 /* PROBLEM_TYPE_PREGNANCY_NUTRITION */:
      return "PROBLEM_TYPE_PREGNANCY_NUTRITION";
    case 31 /* PROBLEM_TYPE_PREGNANCY_PHYSIO */:
      return "PROBLEM_TYPE_PREGNANCY_PHYSIO";
    case 32 /* PROBLEM_TYPE_PREMATURE */:
      return "PROBLEM_TYPE_PREMATURE";
    case 33 /* PROBLEM_TYPE_SKIN_GENERAL */:
      return "PROBLEM_TYPE_SKIN_GENERAL";
    case 34 /* PROBLEM_TYPE_SLEEP */:
      return "PROBLEM_TYPE_SLEEP";
    case 35 /* PROBLEM_TYPE_STI */:
      return "PROBLEM_TYPE_STI";
    case 36 /* PROBLEM_TYPE_UTI */:
      return "PROBLEM_TYPE_UTI";
    case 37 /* PROBLEM_TYPE_WEIGHT_LOSS */:
      return "PROBLEM_TYPE_WEIGHT_LOSS";
    case 38 /* PROBLEM_TYPE_WOMENS_HEALTH */:
      return "PROBLEM_TYPE_WOMENS_HEALTH";
    case -1 /* UNRECOGNIZED */:
    default:
      return "UNRECOGNIZED";
  }
}
var QuizCode = /* @__PURE__ */ ((QuizCode2) => {
  QuizCode2[QuizCode2["QUIZ_CODE_UNSPECIFIED"] = 0] = "QUIZ_CODE_UNSPECIFIED";
  QuizCode2[QuizCode2["QUIZ_CODE_WEIGHT_CHECK_IN"] = 1] = "QUIZ_CODE_WEIGHT_CHECK_IN";
  QuizCode2[QuizCode2["QUIZ_CODE_SKIN_CHECK_IN"] = 2] = "QUIZ_CODE_SKIN_CHECK_IN";
  QuizCode2[QuizCode2["QUIZ_CODE_LEVELS_TREE_QUIZ"] = 3] = "QUIZ_CODE_LEVELS_TREE_QUIZ";
  QuizCode2[QuizCode2["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
  return QuizCode2;
})(QuizCode || {});
function quizCodeFromJSON(object) {
  switch (object) {
    case 0:
    case "QUIZ_CODE_UNSPECIFIED":
      return 0 /* QUIZ_CODE_UNSPECIFIED */;
    case 1:
    case "QUIZ_CODE_WEIGHT_CHECK_IN":
      return 1 /* QUIZ_CODE_WEIGHT_CHECK_IN */;
    case 2:
    case "QUIZ_CODE_SKIN_CHECK_IN":
      return 2 /* QUIZ_CODE_SKIN_CHECK_IN */;
    case 3:
    case "QUIZ_CODE_LEVELS_TREE_QUIZ":
      return 3 /* QUIZ_CODE_LEVELS_TREE_QUIZ */;
    case -1:
    case "UNRECOGNIZED":
    default:
      return -1 /* UNRECOGNIZED */;
  }
}
function quizCodeToJSON(object) {
  switch (object) {
    case 0 /* QUIZ_CODE_UNSPECIFIED */:
      return "QUIZ_CODE_UNSPECIFIED";
    case 1 /* QUIZ_CODE_WEIGHT_CHECK_IN */:
      return "QUIZ_CODE_WEIGHT_CHECK_IN";
    case 2 /* QUIZ_CODE_SKIN_CHECK_IN */:
      return "QUIZ_CODE_SKIN_CHECK_IN";
    case 3 /* QUIZ_CODE_LEVELS_TREE_QUIZ */:
      return "QUIZ_CODE_LEVELS_TREE_QUIZ";
    case -1 /* UNRECOGNIZED */:
    default:
      return "UNRECOGNIZED";
  }
}
var Pharmacy = /* @__PURE__ */ ((Pharmacy2) => {
  Pharmacy2[Pharmacy2["PHARMACY_UNSPECIFIED"] = 0] = "PHARMACY_UNSPECIFIED";
  Pharmacy2[Pharmacy2["PHARMACY_IWG"] = 1] = "PHARMACY_IWG";
  Pharmacy2[Pharmacy2["PHARMACY_CLOUD"] = 2] = "PHARMACY_CLOUD";
  Pharmacy2[Pharmacy2["PHARMACY_UK_PHARMACY"] = 3] = "PHARMACY_UK_PHARMACY";
  Pharmacy2[Pharmacy2["PHARMACY_YSCP_MEL"] = 4] = "PHARMACY_YSCP_MEL";
  Pharmacy2[Pharmacy2["PHARMACY_YSCP_BNE"] = 5] = "PHARMACY_YSCP_BNE";
  Pharmacy2[Pharmacy2["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
  return Pharmacy2;
})(Pharmacy || {});
function pharmacyFromJSON(object) {
  switch (object) {
    case 0:
    case "PHARMACY_UNSPECIFIED":
      return 0 /* PHARMACY_UNSPECIFIED */;
    case 1:
    case "PHARMACY_IWG":
      return 1 /* PHARMACY_IWG */;
    case 2:
    case "PHARMACY_CLOUD":
      return 2 /* PHARMACY_CLOUD */;
    case 3:
    case "PHARMACY_UK_PHARMACY":
      return 3 /* PHARMACY_UK_PHARMACY */;
    case 4:
    case "PHARMACY_YSCP_MEL":
      return 4 /* PHARMACY_YSCP_MEL */;
    case 5:
    case "PHARMACY_YSCP_BNE":
      return 5 /* PHARMACY_YSCP_BNE */;
    case -1:
    case "UNRECOGNIZED":
    default:
      return -1 /* UNRECOGNIZED */;
  }
}
function pharmacyToJSON(object) {
  switch (object) {
    case 0 /* PHARMACY_UNSPECIFIED */:
      return "PHARMACY_UNSPECIFIED";
    case 1 /* PHARMACY_IWG */:
      return "PHARMACY_IWG";
    case 2 /* PHARMACY_CLOUD */:
      return "PHARMACY_CLOUD";
    case 3 /* PHARMACY_UK_PHARMACY */:
      return "PHARMACY_UK_PHARMACY";
    case 4 /* PHARMACY_YSCP_MEL */:
      return "PHARMACY_YSCP_MEL";
    case 5 /* PHARMACY_YSCP_BNE */:
      return "PHARMACY_YSCP_BNE";
    case -1 /* UNRECOGNIZED */:
    default:
      return "UNRECOGNIZED";
  }
}
var LanguageCode = /* @__PURE__ */ ((LanguageCode2) => {
  LanguageCode2[LanguageCode2["LANGUAGE_CODE_UNSPECIFIED"] = 0] = "LANGUAGE_CODE_UNSPECIFIED";
  LanguageCode2[LanguageCode2["LANGUAGE_CODE_DE"] = 1] = "LANGUAGE_CODE_DE";
  LanguageCode2[LanguageCode2["LANGUAGE_CODE_EN_AU"] = 2] = "LANGUAGE_CODE_EN_AU";
  LanguageCode2[LanguageCode2["LANGUAGE_CODE_EN_GB"] = 3] = "LANGUAGE_CODE_EN_GB";
  LanguageCode2[LanguageCode2["LANGUAGE_CODE_JA"] = 4] = "LANGUAGE_CODE_JA";
  LanguageCode2[LanguageCode2["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
  return LanguageCode2;
})(LanguageCode || {});
function languageCodeFromJSON(object) {
  switch (object) {
    case 0:
    case "LANGUAGE_CODE_UNSPECIFIED":
      return 0 /* LANGUAGE_CODE_UNSPECIFIED */;
    case 1:
    case "LANGUAGE_CODE_DE":
      return 1 /* LANGUAGE_CODE_DE */;
    case 2:
    case "LANGUAGE_CODE_EN_AU":
      return 2 /* LANGUAGE_CODE_EN_AU */;
    case 3:
    case "LANGUAGE_CODE_EN_GB":
      return 3 /* LANGUAGE_CODE_EN_GB */;
    case 4:
    case "LANGUAGE_CODE_JA":
      return 4 /* LANGUAGE_CODE_JA */;
    case -1:
    case "UNRECOGNIZED":
    default:
      return -1 /* UNRECOGNIZED */;
  }
}
function languageCodeToJSON(object) {
  switch (object) {
    case 0 /* LANGUAGE_CODE_UNSPECIFIED */:
      return "LANGUAGE_CODE_UNSPECIFIED";
    case 1 /* LANGUAGE_CODE_DE */:
      return "LANGUAGE_CODE_DE";
    case 2 /* LANGUAGE_CODE_EN_AU */:
      return "LANGUAGE_CODE_EN_AU";
    case 3 /* LANGUAGE_CODE_EN_GB */:
      return "LANGUAGE_CODE_EN_GB";
    case 4 /* LANGUAGE_CODE_JA */:
      return "LANGUAGE_CODE_JA";
    case -1 /* UNRECOGNIZED */:
    default:
      return "UNRECOGNIZED";
  }
}
var DevicePlatform = /* @__PURE__ */ ((DevicePlatform2) => {
  DevicePlatform2[DevicePlatform2["DEVICE_PLATFORM_UNSPECIFIED"] = 0] = "DEVICE_PLATFORM_UNSPECIFIED";
  DevicePlatform2[DevicePlatform2["DEVICE_PLATFORM_WEB"] = 1] = "DEVICE_PLATFORM_WEB";
  DevicePlatform2[DevicePlatform2["DEVICE_PLATFORM_ANDROID"] = 2] = "DEVICE_PLATFORM_ANDROID";
  DevicePlatform2[DevicePlatform2["DEVICE_PLATFORM_IOS"] = 3] = "DEVICE_PLATFORM_IOS";
  DevicePlatform2[DevicePlatform2["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
  return DevicePlatform2;
})(DevicePlatform || {});
function devicePlatformFromJSON(object) {
  switch (object) {
    case 0:
    case "DEVICE_PLATFORM_UNSPECIFIED":
      return 0 /* DEVICE_PLATFORM_UNSPECIFIED */;
    case 1:
    case "DEVICE_PLATFORM_WEB":
      return 1 /* DEVICE_PLATFORM_WEB */;
    case 2:
    case "DEVICE_PLATFORM_ANDROID":
      return 2 /* DEVICE_PLATFORM_ANDROID */;
    case 3:
    case "DEVICE_PLATFORM_IOS":
      return 3 /* DEVICE_PLATFORM_IOS */;
    case -1:
    case "UNRECOGNIZED":
    default:
      return -1 /* UNRECOGNIZED */;
  }
}
function devicePlatformToJSON(object) {
  switch (object) {
    case 0 /* DEVICE_PLATFORM_UNSPECIFIED */:
      return "DEVICE_PLATFORM_UNSPECIFIED";
    case 1 /* DEVICE_PLATFORM_WEB */:
      return "DEVICE_PLATFORM_WEB";
    case 2 /* DEVICE_PLATFORM_ANDROID */:
      return "DEVICE_PLATFORM_ANDROID";
    case 3 /* DEVICE_PLATFORM_IOS */:
      return "DEVICE_PLATFORM_IOS";
    case -1 /* UNRECOGNIZED */:
    default:
      return "UNRECOGNIZED";
  }
}
var DayOfWeek = /* @__PURE__ */ ((DayOfWeek2) => {
  DayOfWeek2[DayOfWeek2["DAY_OF_WEEK_UNSPECIFIED"] = 0] = "DAY_OF_WEEK_UNSPECIFIED";
  DayOfWeek2[DayOfWeek2["DAY_OF_WEEK_MONDAY"] = 1] = "DAY_OF_WEEK_MONDAY";
  DayOfWeek2[DayOfWeek2["DAY_OF_WEEK_TUESDAY"] = 2] = "DAY_OF_WEEK_TUESDAY";
  DayOfWeek2[DayOfWeek2["DAY_OF_WEEK_WEDNESDAY"] = 3] = "DAY_OF_WEEK_WEDNESDAY";
  DayOfWeek2[DayOfWeek2["DAY_OF_WEEK_THURSDAY"] = 4] = "DAY_OF_WEEK_THURSDAY";
  DayOfWeek2[DayOfWeek2["DAY_OF_WEEK_FRIDAY"] = 5] = "DAY_OF_WEEK_FRIDAY";
  DayOfWeek2[DayOfWeek2["DAY_OF_WEEK_SATURDAY"] = 6] = "DAY_OF_WEEK_SATURDAY";
  DayOfWeek2[DayOfWeek2["DAY_OF_WEEK_SUNDAY"] = 7] = "DAY_OF_WEEK_SUNDAY";
  DayOfWeek2[DayOfWeek2["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
  return DayOfWeek2;
})(DayOfWeek || {});
function dayOfWeekFromJSON(object) {
  switch (object) {
    case 0:
    case "DAY_OF_WEEK_UNSPECIFIED":
      return 0 /* DAY_OF_WEEK_UNSPECIFIED */;
    case 1:
    case "DAY_OF_WEEK_MONDAY":
      return 1 /* DAY_OF_WEEK_MONDAY */;
    case 2:
    case "DAY_OF_WEEK_TUESDAY":
      return 2 /* DAY_OF_WEEK_TUESDAY */;
    case 3:
    case "DAY_OF_WEEK_WEDNESDAY":
      return 3 /* DAY_OF_WEEK_WEDNESDAY */;
    case 4:
    case "DAY_OF_WEEK_THURSDAY":
      return 4 /* DAY_OF_WEEK_THURSDAY */;
    case 5:
    case "DAY_OF_WEEK_FRIDAY":
      return 5 /* DAY_OF_WEEK_FRIDAY */;
    case 6:
    case "DAY_OF_WEEK_SATURDAY":
      return 6 /* DAY_OF_WEEK_SATURDAY */;
    case 7:
    case "DAY_OF_WEEK_SUNDAY":
      return 7 /* DAY_OF_WEEK_SUNDAY */;
    case -1:
    case "UNRECOGNIZED":
    default:
      return -1 /* UNRECOGNIZED */;
  }
}
function dayOfWeekToJSON(object) {
  switch (object) {
    case 0 /* DAY_OF_WEEK_UNSPECIFIED */:
      return "DAY_OF_WEEK_UNSPECIFIED";
    case 1 /* DAY_OF_WEEK_MONDAY */:
      return "DAY_OF_WEEK_MONDAY";
    case 2 /* DAY_OF_WEEK_TUESDAY */:
      return "DAY_OF_WEEK_TUESDAY";
    case 3 /* DAY_OF_WEEK_WEDNESDAY */:
      return "DAY_OF_WEEK_WEDNESDAY";
    case 4 /* DAY_OF_WEEK_THURSDAY */:
      return "DAY_OF_WEEK_THURSDAY";
    case 5 /* DAY_OF_WEEK_FRIDAY */:
      return "DAY_OF_WEEK_FRIDAY";
    case 6 /* DAY_OF_WEEK_SATURDAY */:
      return "DAY_OF_WEEK_SATURDAY";
    case 7 /* DAY_OF_WEEK_SUNDAY */:
      return "DAY_OF_WEEK_SUNDAY";
    case -1 /* UNRECOGNIZED */:
    default:
      return "UNRECOGNIZED";
  }
}
var AuState = /* @__PURE__ */ ((AuState2) => {
  AuState2[AuState2["AU_STATE_UNSPECIFIED"] = 0] = "AU_STATE_UNSPECIFIED";
  AuState2[AuState2["AU_STATE_NSW"] = 1] = "AU_STATE_NSW";
  AuState2[AuState2["AU_STATE_QLD"] = 2] = "AU_STATE_QLD";
  AuState2[AuState2["AU_STATE_SA"] = 3] = "AU_STATE_SA";
  AuState2[AuState2["AU_STATE_TAS"] = 4] = "AU_STATE_TAS";
  AuState2[AuState2["AU_STATE_VIC"] = 5] = "AU_STATE_VIC";
  AuState2[AuState2["AU_STATE_WA"] = 6] = "AU_STATE_WA";
  AuState2[AuState2["AU_STATE_ACT"] = 7] = "AU_STATE_ACT";
  AuState2[AuState2["AU_STATE_NT"] = 8] = "AU_STATE_NT";
  AuState2[AuState2["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
  return AuState2;
})(AuState || {});
function auStateFromJSON(object) {
  switch (object) {
    case 0:
    case "AU_STATE_UNSPECIFIED":
      return 0 /* AU_STATE_UNSPECIFIED */;
    case 1:
    case "AU_STATE_NSW":
      return 1 /* AU_STATE_NSW */;
    case 2:
    case "AU_STATE_QLD":
      return 2 /* AU_STATE_QLD */;
    case 3:
    case "AU_STATE_SA":
      return 3 /* AU_STATE_SA */;
    case 4:
    case "AU_STATE_TAS":
      return 4 /* AU_STATE_TAS */;
    case 5:
    case "AU_STATE_VIC":
      return 5 /* AU_STATE_VIC */;
    case 6:
    case "AU_STATE_WA":
      return 6 /* AU_STATE_WA */;
    case 7:
    case "AU_STATE_ACT":
      return 7 /* AU_STATE_ACT */;
    case 8:
    case "AU_STATE_NT":
      return 8 /* AU_STATE_NT */;
    case -1:
    case "UNRECOGNIZED":
    default:
      return -1 /* UNRECOGNIZED */;
  }
}
function auStateToJSON(object) {
  switch (object) {
    case 0 /* AU_STATE_UNSPECIFIED */:
      return "AU_STATE_UNSPECIFIED";
    case 1 /* AU_STATE_NSW */:
      return "AU_STATE_NSW";
    case 2 /* AU_STATE_QLD */:
      return "AU_STATE_QLD";
    case 3 /* AU_STATE_SA */:
      return "AU_STATE_SA";
    case 4 /* AU_STATE_TAS */:
      return "AU_STATE_TAS";
    case 5 /* AU_STATE_VIC */:
      return "AU_STATE_VIC";
    case 6 /* AU_STATE_WA */:
      return "AU_STATE_WA";
    case 7 /* AU_STATE_ACT */:
      return "AU_STATE_ACT";
    case 8 /* AU_STATE_NT */:
      return "AU_STATE_NT";
    case -1 /* UNRECOGNIZED */:
    default:
      return "UNRECOGNIZED";
  }
}
var Interval_Type = /* @__PURE__ */ ((Interval_Type2) => {
  Interval_Type2[Interval_Type2["TYPE_UNSPECIFIED"] = 0] = "TYPE_UNSPECIFIED";
  Interval_Type2[Interval_Type2["TYPE_DAYS"] = 1] = "TYPE_DAYS";
  Interval_Type2[Interval_Type2["TYPE_MONTHS"] = 2] = "TYPE_MONTHS";
  Interval_Type2[Interval_Type2["TYPE_HOURS"] = 3] = "TYPE_HOURS";
  Interval_Type2[Interval_Type2["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
  return Interval_Type2;
})(Interval_Type || {});
function interval_TypeFromJSON(object) {
  switch (object) {
    case 0:
    case "TYPE_UNSPECIFIED":
      return 0 /* TYPE_UNSPECIFIED */;
    case 1:
    case "TYPE_DAYS":
      return 1 /* TYPE_DAYS */;
    case 2:
    case "TYPE_MONTHS":
      return 2 /* TYPE_MONTHS */;
    case 3:
    case "TYPE_HOURS":
      return 3 /* TYPE_HOURS */;
    case -1:
    case "UNRECOGNIZED":
    default:
      return -1 /* UNRECOGNIZED */;
  }
}
function interval_TypeToJSON(object) {
  switch (object) {
    case 0 /* TYPE_UNSPECIFIED */:
      return "TYPE_UNSPECIFIED";
    case 1 /* TYPE_DAYS */:
      return "TYPE_DAYS";
    case 2 /* TYPE_MONTHS */:
      return "TYPE_MONTHS";
    case 3 /* TYPE_HOURS */:
      return "TYPE_HOURS";
    case -1 /* UNRECOGNIZED */:
    default:
      return "UNRECOGNIZED";
  }
}
function createBasePageRequest() {
  return { pageSize: void 0, pageToken: void 0, skip: void 0 };
}
const PageRequest = {
  encode(message, writer = import_minimal.default.Writer.create()) {
    if (message.pageSize !== void 0) {
      writer.uint32(8).int32(message.pageSize);
    }
    if (message.pageToken !== void 0) {
      writer.uint32(18).string(message.pageToken);
    }
    if (message.skip !== void 0) {
      writer.uint32(24).int32(message.skip);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof import_minimal.default.Reader ? input : import_minimal.default.Reader.create(input);
    let end = length === void 0 ? reader.len : reader.pos + length;
    const message = createBasePageRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }
          message.pageSize = reader.int32();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.pageToken = reader.string();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }
          message.skip = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON(object) {
    return {
      pageSize: isSet(object.pageSize) ? Number(object.pageSize) : void 0,
      pageToken: isSet(object.pageToken) ? String(object.pageToken) : void 0,
      skip: isSet(object.skip) ? Number(object.skip) : void 0
    };
  },
  toJSON(message) {
    const obj = {};
    if (message.pageSize !== void 0) {
      obj.pageSize = Math.round(message.pageSize);
    }
    if (message.pageToken !== void 0) {
      obj.pageToken = message.pageToken;
    }
    if (message.skip !== void 0) {
      obj.skip = Math.round(message.skip);
    }
    return obj;
  },
  create(base) {
    return PageRequest.fromPartial(base ?? {});
  },
  fromPartial(object) {
    const message = createBasePageRequest();
    message.pageSize = object.pageSize ?? void 0;
    message.pageToken = object.pageToken ?? void 0;
    message.skip = object.skip ?? void 0;
    return message;
  }
};
function createBaseInterval() {
  return { type: 0, count: void 0 };
}
const Interval = {
  encode(message, writer = import_minimal.default.Writer.create()) {
    if (message.type !== 0) {
      writer.uint32(8).int32(message.type);
    }
    if (message.count !== void 0) {
      import_wrappers.Int32Value.encode({ value: message.count }, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof import_minimal.default.Reader ? input : import_minimal.default.Reader.create(input);
    let end = length === void 0 ? reader.len : reader.pos + length;
    const message = createBaseInterval();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }
          message.type = reader.int32();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }
          message.count = import_wrappers.Int32Value.decode(reader, reader.uint32()).value;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON(object) {
    return {
      type: isSet(object.type) ? interval_TypeFromJSON(object.type) : 0,
      count: isSet(object.count) ? Number(object.count) : void 0
    };
  },
  toJSON(message) {
    const obj = {};
    if (message.type !== 0) {
      obj.type = interval_TypeToJSON(message.type);
    }
    if (message.count !== void 0) {
      obj.count = message.count;
    }
    return obj;
  },
  create(base) {
    return Interval.fromPartial(base ?? {});
  },
  fromPartial(object) {
    const message = createBaseInterval();
    message.type = object.type ?? 0;
    message.count = object.count ?? void 0;
    return message;
  }
};
function isSet(value) {
  return value !== null && value !== void 0;
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  AuState,
  Brand,
  DayOfWeek,
  DevicePlatform,
  Interval,
  Interval_Type,
  LanguageCode,
  PageRequest,
  Pharmacy,
  ProblemType,
  QuizCode,
  auStateFromJSON,
  auStateToJSON,
  brandFromJSON,
  brandToJSON,
  dayOfWeekFromJSON,
  dayOfWeekToJSON,
  devicePlatformFromJSON,
  devicePlatformToJSON,
  interval_TypeFromJSON,
  interval_TypeToJSON,
  languageCodeFromJSON,
  languageCodeToJSON,
  pharmacyFromJSON,
  pharmacyToJSON,
  problemTypeFromJSON,
  problemTypeToJSON,
  protobufPackage,
  quizCodeFromJSON,
  quizCodeToJSON
});
//# sourceMappingURL=globals.js.map
